module.exports = __webpack_public_path__ + "img/charges.53483fcf.svg";